<script>
  import { onMount, setContext } from 'svelte';
  import { writable } from 'svelte/store';
  import { orderBy, find } from 'lodash-es';

  import Waypoint from 'svelte-waypoint';

  import Router from './Router.svelte';

  import SelectionView from './components/SelectionView.svelte';
  import Viz from './components/Viz.svelte';
  import TooltipView from './components/TooltipView.svelte';
  import SoundCloudPlayer from './components/SoundCloudPlayer.svelte';

  import { modeOptions, soundcloudUrl } from './config.js';
  import { dataSet } from './data/DataStore.js';
  import { selectedItemId, hoveredItemId, modeId } from './state/uiState.js';
  // get aspects from data set
  $: items = $dataSet.items;

  // resolve dependencies/lookups between global uistate and loaded data

  $: selectedItem = find(items, x => x.id === $selectedItemId);

  $: hoveredItem = find(items, x => x.id === $hoveredItemId);

  $: modeStore = find(items, x => x.id === $modeId);

  let player;
  let duration;
  let currentTime;
  let time;
  let paused;
  let clientWidth;
  let bigImageWidth = 30513;

  $: percentComplete = (100 * time) / duration;

  $: {
    console.log(bigImageWidth);
    console.log(clientWidth);
  }
</script>

<style lang="scss" global>
  @import './styles/reset.scss';
  @import './styles/theme.scss';
  @import './styles/base.scss';

  body {
    background: #000;
    color: #fff;
  }

  header {
    @include fluid-space(padding, 0.5);
    width: 100vw;
    display: flex;
    align-items: flex-end;
  }

  select {
    max-width: 20em;
  }
  main {
    display: flex;
    flex-direction: column;
  }

  footer {
    background: $c-gray-4;
    @include fluid-font-size($fs-small);
    display: grid;
    align-items: center;
    justify-items: center;
  }

  footer > div {
    display: grid;
    max-width: 40rem;
    width: 100vw;

    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    @include fluid-space(grid-gap, 2);
    @include fluid-space(padding, 2);
    @include fluid-font-size($fs-small);
  }

  .main-grid {
    border-top: 1px solid $c-gray-4;
    display: grid;
    align-items: center;
    justify-items: center;
    max-width: 100vw;
    @include fluid-space(grid-gap, 2);
    @include fluid-space(padding, 2);
  }

  .text-box {
    max-width: 40em;
  }

  img {
    display: block;
  }

  .progress-marker {
    border: 2px solid #d0ff00;
    width: 1px;
    height: 100%;
    top: 0;
    position: absolute;
    mix-blend-mode: screen;
  }

  .big-image-container {
    position: relative;
    margin-left: 50%;
  }

  .spectro {
    height: 10em;
  }
</style>

<SoundCloudPlayer
  bind:this="{player}"
  url="{soundcloudUrl}"
  bind:time
  bind:duration
  bind:paused />

<div
  class="big-image-container"
  on:click="{event =>
    player.seek(
      time + duration * ((event.clientX - clientWidth / 2) / bigImageWidth),
    )}">
  <img
    class="big-image"
    style="margin-left: -30px; max-width: none; width: auto; height: auto;
    transform:translate(-{percentComplete}%, 0)"
    src="images/30k.png" />
  <div class="progress-marker"></div>
</div>

<div bind:clientWidth="{clientWidth}" style="position: relative;">
  <img
    on:click="{event => player.seek(duration * (event.clientX / clientWidth))}"
    class="spectro"
    src="images/30k.png" />
  <div class="progress-marker" style="left: {percentComplete}%"></div>
</div>

<TooltipView item="{hoveredItem}" />

<!-- Router needs to be last so initial state is handled correctly in previous views -->
<Router stores="{[modeId, selectedItemId]}" />
